"use client";

import { createIcon } from "@chakra-ui/react";

const ArrowRightSvgIcon = createIcon({
  displayName: "ArrowRightSvgIcon",
  viewBox: "0 0 24 24",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" d="M22.4142 12L14 20.4142L12.5858 19L18.5858 13L2 13L2 11L18.5858 11L12.5858 5.00003L14 3.58582L22.4142 12Z" fill="" />
  ),
});

export default ArrowRightSvgIcon;
